import { Breadcrumbs, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { styled } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faHouseUser, faUserCheck, faUsersClass } from "@fortawesome/pro-duotone-svg-icons";
const StyledLink = styled(Link)({
    color: "var(--text-color)",
    textDecoration: "none",
});
const ToolsBreadcrumb = ({ item }) => {
    return (
        <Breadcrumbs aria-label='breadcrumb'>
            <StyledLink to={"/"}>
                <FontAwesomeIcon icon={faHouse} />
                &nbsp;Home
            </StyledLink>
            <StyledLink to={"/super/tools"}>
                <FontAwesomeIcon icon={faHouseUser} />
                &nbsp;Admin Tools
            </StyledLink>
            {item ? <Typography color='textPrimary'>{item.label}</Typography> : ""}
        </Breadcrumbs>
    );
};

export default ToolsBreadcrumb;
